import React from 'react';
import ReactDOM from 'react-dom/client';
import AdminApp from './AdminApp';
import './styles/globals.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<AdminApp />);